<template>
  <div class="container w-50">
    <loading loader="bars" :active.sync="isLoading"></loading>
    <div class="row mt-3">
      <div class="col-12">
        <div class="row w-75 mx-auto">
          <div class="col-sm-3">
            <div class="row">
              <div class="col-12 roleBox">
                <button type="button" class="btn roleBtn mb-2 btn-block" v-for="item in roles" :key="item.Id" @click="roleTime(item.Id)">{{ item.BusinessRoleName }}</button>
              </div>
              <div class="col-12 d-block d-sm-none">
                <DatePicker
                  v-model="date"
                  is-inline
                  is-expanded
                  :disabled-dates="{ weekdays: this.rolePeriod }"
                />
              </div>
              <div class="col-12 mt-3 mt-sm-0">
                <p class="h3 text-center brown">預約時間</p>
                <div class="d-flex">
                  <select class="custom-select custom-select-sm" v-model="data.Hour">
                    <option v-for="index in 25" :key="index" :value="index-1">{{ index-1 }}</option>
                  </select>
                  :
                  <select class="custom-select custom-select-sm" v-model="data.Minute">
                    <option v-for="index in 60" :key="index" :value="index-1">{{ index-1 }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-9 d-none d-sm-block">
            <DatePicker
              class="date"
              v-model="date"
              color="orange"
              is-inline
              is-expanded
              title-position="left"
              :disabled-dates="{ weekdays: this.rolePeriod }"
            />
          </div>
        </div>
      </div>
      <div class="col-12 mt-2">
        <div class="row w-75 mx-auto">
          <div class="col-sm-6">
            <p class="h3 text-center d-block d-sm-none brown">預約資料</p>
            <p class="h4 mt-2 mb-2 brown"><i class="las la-user-circle"></i> {{ user.CustomerName }} {{ user.CustomerGender }}</p>
            <p class="h4 mb-3 brown"><i class="las la-mobile"></i>  {{ user.CustomerPhone }}</p>
            <div class="row mb-2">
              <div class="col-4">
                <label for="adult" class="brown">
                  <i class="las la-lg la-user-alt"></i>大人
                </label>
                <select class="form-control form-control-sm" id="adult" v-model="data.Adult">
                  <option v-for="index in 100" :key="index" :value="index-1">{{ index-1 }}</option>
                </select>
              </div>
              <div class="col-4">
                <label for="child" class="brown">
                  <i class="las la-lg la-child"></i>小孩
                </label>
                <select class="form-control form-control-sm" id="child" v-model="data.Children">
                  <option v-for="index in 100" :key="index" :value="index-1">{{ index-1 }}</option>
                </select>
              </div>
              <div class="col-4">
                <label for="baby" class="brown">
                  <i class="las la-lg la-baby-carriage"></i>嬰兒
                </label>
                <select class="form-control form-control-sm" id="baby" v-model="data.Baby">
                  <option v-for="index in 100" :key="index" :value="index-1">{{ index-1 }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <label for="note" class="brown">
              跟店家說:
            </label>
            <textarea class="form-control mb-2" id="note" rows="3" v-model="data.Note"></textarea>
            <button type="button" class="btn send-btn btn-sm btn-block" @click="send">送出</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
export default {
  components: {
    DatePicker
  },
  data () {
    return {
      date: new Date(),
      roles: [],
      rolePeriod: [],
      user: {},
      data: {
        Hour: 0,
        Minute: 0,
        Adult: 0,
        Children: 0,
        Baby: 0,
        Note: '',
        role: ''
      },
      isLoading: false
    }
  },
  computed: {
    ConversionDate () {
      const Year = this.date.getFullYear()
      const Month = this.date.getMonth() + 1
      const Day = this.date.getDate()
      return `${Year}/${Month}/${Day}`
    }
  },
  methods: {
    roleTime (id) {
      const vm = this
      const time = 'http://imrebooksystem.rocket-coding.com/CustomerUsers/GetRoleOpenTime'
      const weeks = []
      const no = []
      const yes = []
      this.data.role = id
      this.axios.get(time, {
        params: { id: id }
      })
        .then(function (res) {
          // 取出所以時間
          res.data.forEach(element => {
            weeks.push(element.Week)
          })
          // 分是否營業
          weeks.forEach(element => {
            element.forEach(element => {
              if (element.Enable === false) {
                no.push(parseInt(element.WeekDay))
              } else if (element.Enable === true) {
                yes.push(parseInt(element.WeekDay))
              }
            })
          })
          var resultNo = [...(new Set(no))].sort()
          var resultYes = [...(new Set(yes))].sort()
          const newArr = []
          resultNo.forEach((item) => {
            if (resultYes.indexOf(item) === -1) {
              newArr.push(item)
            }
          })
          vm.rolePeriod = newArr
        })
        .catch(error => console.error(error))
    },
    send () {
      this.isLoading = true
      const vm = this
      const d = this.data
      if (d.role === '') {
        vm.$swal({
          position: 'top-end',
          background: '#F7ECEB',
          icon: 'warning',
          title: '請選擇要預約的對象~',
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          onOpen: toast => {
            toast.addEventListener('mouseenter', vm.$swal.stopTimer)
            toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
          }
        })
      } else if (d.Hour === 0 || d.Minute === 0) {
        vm.$swal({
          position: 'top-end',
          background: '#F7ECEB',
          icon: 'warning',
          title: '請選擇預約時間哦~',
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          onOpen: toast => {
            toast.addEventListener('mouseenter', vm.$swal.stopTimer)
            toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
          }
        })
      } else if (d.Adult === 0 && d.Children === 0 && d.Baby === 0) {
        vm.$swal({
          position: 'top-end',
          background: '#F7ECEB',
          icon: 'warning',
          title: '請選擇人數哦~',
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          onOpen: toast => {
            toast.addEventListener('mouseenter', vm.$swal.stopTimer)
            toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
          }
        })
      } else {
        const url = 'http://imrebooksystem.rocket-coding.com/Dashboard/CreateNetWorkBook'
        vm.axios.post(url, {
          CustomerUserId: vm.user.Id,
          RoleId: d.role,
          OrderDate: `${vm.ConversionDate} ${d.Hour}:${d.Minute}`,
          OrderAdultPeople: d.Adult,
          OrderChildrenPeople: d.Children,
          OrderBabyPeople: d.Baby,
          CustomerNote: d.Note
        })
          .then(function (res) {
            if (res.data === '預約成功') {
              vm.isLoading = false
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'success',
                title: '預約成功',
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                onOpen: toast => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
                }
              })
              vm.$router.push('/')
            } else {
              vm.isLoading = false
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'error',
                title: res.data,
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                onOpen: toast => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
                }
              })
            }
          })
          .catch(error => console.error(error))
      }
    }
  },
  created () {
    this.isLoading = true
    this.user = JSON.parse(sessionStorage.getItem('user'))
    if (this.user === null) {
      this.$store.commit('openSignIn', 'null')
    } else {
      const vm = this
      const roleUrl = 'http://imrebooksystem.rocket-coding.com/BusinessRoles/GetRoleList'
      this.axios.get(roleUrl, {
        params: { id: vm.$route.params.BusinessId }
      })
        .then(function (res) {
          vm.roles = res.data
          vm.isLoading = false
        })
        .catch(error => console.error(error))
    }
  }
}
</script>

<style lang="scss" scoped>
select,
input,
textarea,
.date {
  background-color: transparent;
  border-color: #b8817d;
  color: #b8817d;
}
select:focus,
input:focus,
textarea:focus {
  background-color: transparent;
  color: #b8817d;
}
.date {
  color: #b8817d;
}
.roleBox {
  min-width: 100%;
  height: 190px;
  overflow-y: auto;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.roleBox::-webkit-scrollbar {
  width: 0 !important;
}
.send-btn {
  background-color: transparent;
  border: 1px solid #b8817d;
  color: #b8817d;
  transition: 1s;
}
.send-btn:hover {
  border: 1px solid transparent;
  color: #545871;
  background-color: #ebd0ce;
  transition: 1s;
}
.borderColor{
  border-color: #b8817d !important;
  color: #b8817d;
}
.roleBtn{
  background-color: transparent;
  color: #b8817d;
  border-radius: 5px;
  border: 1px solid #b8817d;
  transition: 1s;
}
.roleBtn:hover,
.roleBtn:focus{
  background-color: #ebd0ce;
  color: #b8817d;
  border: 1px solid transparent;
  transition: 1s;
}
@media (max-width: 1200px) {
  .w-50 {
    width: 75% !important;
  }
  .w-75 {
    width: 100% !important;
  }
  .h3 {
    font-size: 1.5rem;
  }
}
@media (max-width: 576px) {
  .w-50,
  .w-75 {
    width: 100% !important;
  }
  .roleBox {
    min-width: 100%;
    height: 70px;
  }
}
</style>
